import { Button, FluentProvider, webLightTheme } from "@fluentui/react-components";
import React from "react";
import ADXLogo from "../images/azure-data-explorer.png";
import { openQueryInADX } from "../Utils/adx-utils";
import { ExploreDataButtonWithDialogProps } from "./Interfaces/ExploreDataButtonWithDialog.interfaces";

/**
 * A Fluent UI button component that opens the Kusto query in Azure Data Explorer.
 * Directly opens ADX in a new tab when clicked.
 */

const styles = {
  button: {
    marginLeft: 4,
    padding: "var(--spacingHorizontalXS) 5px"
  } as React.CSSProperties
};

export const ExploreDataButtonWithDialog: React.FC<ExploreDataButtonWithDialogProps> = ({
  buttonText = "Explore Data",
  className,
  disabled = false,
  onRedirectComplete,
  query,
  style
}) => {
  const handleButtonClick = () => {
    onRedirectComplete?.();
    openQueryInADX(query);
  };

  return (
    <FluentProvider theme={webLightTheme}>
      <Button
        appearance="subtle"
        className={className}
        disabled={disabled || !query?.trim()}
        icon={<img src={ADXLogo} width={35} alt="icon" />}
        onClick={handleButtonClick}
        style={style ?? styles.button}
      >
        {buttonText}
      </Button>
    </FluentProvider>
  );
};

export default ExploreDataButtonWithDialog;
